export enum PreQualificationStep {
  BorrowerIdentity = 'BorrowerIdentity',
  LoanInformation = 'LoanInformation',
  BorrowerPhoneVerification = 'BorrowerPhoneVerification',
  CoBorrowerPhoneVerification = 'CoBorrowerPhoneVerification',
  VerificationComplete = 'VerificationComplete',
  BorrowerInfo = 'BorrowerInfo',
  CoBorrowerInfo = 'CoBorrowerInfo',
  BorrowerIncome = 'BorrowerIncome',
  CoBorrowerIncome = 'CoBorrowerIncome',
  Contractor = 'Contractor',
  SignIn = 'SignIn',
  CreateAccount = 'CreateAccount',
  AlreadyHaveActiveApplication = 'AlreadyHaveActiveApplication',
  BorrowerAsCoBorrowerAlreadyHaveActiveApplication = 'BorrowerAsCoborrowerAlreadyHaveActiveApplication',
  CoBorrowerAlreadyHaveActiveApplication = 'CoBorrowerAlreadyHaveActiveApplication',
  NotAbleToAccept = 'NotAbleToAccept',
  UnfreezeCredit = 'UnfreezeCredit',
  NoOptions = 'NoOptions',
  Decline = 'Decline',
  RedirectToProveLink = 'RedirectToProveLink',
  NotFoundContact = 'NotFoundContact',
  PropertyInformation = 'PropertyInformation',
  NewInquiry = 'New Inquiry',
  AcceptManualOneTermOffer = 'AcceptManualOneTermOffer',
  AcceptManualMultiTermOffer = 'AcceptManualMultiTermOffer',
  AcceptPosAutomatedOffer = 'Accept Pos Automated Offer',
  AcceptHilAutomatedOffer = 'Accept Hil Automated Offer',
  PromptToAddCoBorrower = 'PromptToAddCoBorrower',
  CoBorrowerHasApplication = 'CoBorrowerHasApplication',
  AdditionalCoBorrowerInfo = 'AdditionalCoBorrowerInfo',
}
